module.exports = __webpack_public_path__ + "files/19d7ec4810d6130aa5613e012ef0614e.png";